import React from 'react';
import { Reveal } from './Reveal';

/**
 * Standardized section heading used on every block.
 * Provides consistent vertical rhythm and hierarchy.
 */
export const SectionHeading = ({
  eyebrow,
  title,
  lead,
  align = 'left', // 'left' | 'center'
  as: As = 'h2',
  className = '',
}) => {
  const alignCls = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return (
    <header className={`max-w-3xl ${alignCls} ${className}`}>
      {eyebrow && (
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <Reveal delay={60}>
        <As className={`mt-5 ${As === 'h1' ? 'text-h1 md:text-h1' : 'text-h2'} text-ink`}>
          {title}
        </As>
      </Reveal>
      {lead && (
        <Reveal delay={120}>
          <p className="mt-5 text-body-lg text-ink-muted max-w-2xl">{lead}</p>
        </Reveal>
      )}
    </header>
  );
};

export default SectionHeading;
